import { z as e } from "zod";
const i = e.object({
  supplier: e.string(),
  overall_contract_price: e.number(),
  overall_contract_value: e.number(),
  annualized_contract_price: e.number(),
  overall_contract_discount: e.number(),
  distribution: e.union([
    e.object({
      percentile: e.number(),
      q1: e.number(),
      q2: e.number().nullish(),
      q3: e.number()
    }),
    e.number()
  ]).nullable(),
  start_date_of_contract: e.string().nullish(),
  end_date_of_contract: e.string().nullish(),
  sku_documents_count: e.number().int(),
  value_dimension: e.enum(["TotalContractPrice", "DiscountPercent"]),
  low_value_point: e.number().nullable(),
  high_value_point: e.number().nullable()
}), t = e.object({
  id: e.string(),
  sku_id: e.string().nullish(),
  name: e.string(),
  name_in_document: e.string(),
  entity_type: e.enum(["Product", "Tier", "Addon"]).nullish(),
  currency_code: e.string().nullable(),
  quantity: e.number().int().nullable(),
  discount_percentage: e.number(),
  unitized_price: e.number(),
  annual_unit_price: e.number().nullish(),
  total_price: e.number(),
  term_month: e.number().nullish(),
  pricing_unit_name: e.string().nullable(),
  pricing_unit_id: e.string().nullish(),
  value_dimension: e.enum(["AnnualUnitPrice", "TotalPrice", "DiscountPercent"]).nullable(),
  bucket_dimension: e.enum(["Quantity", "TotalPrice"]).nullable(),
  bucket: e.object({
    min: e.number(),
    max: e.number()
  }).nullish(),
  annualized_unitized_line_item_distribution: e.array(e.number()).nullish(),
  distribution: e.object({
    percentile: e.number().int(),
    q1: e.number(),
    q2: e.number().nullish(),
    q3: e.number()
  }).nullable(),
  low_value_point: e.number().nullable(),
  high_value_point: e.number().nullable(),
  visualization_type: e.enum(["distribution", "range"])
}), n = e.object({
  id: e.string(),
  name: e.string(),
  value_dimension: e.enum(["TotalContractPrice", "DiscountPercent"]),
  low_value: e.number(),
  high_value: e.number(),
  is_vendr_verified: e.boolean(),
  logo_url: e.string(),
  value_unit: e.string()
}), a = e.object({
  display_name: e.string().describe("The display name of the negotiation tactic."),
  description: e.string().min(1).describe(
    "A paragraph describing the negotiation tactic. Make sure you explain what the tactic is, but also suggest how to utilize the tactic."
  ),
  savings_potential: e.number().min(1).max(3).describe(
    "savings potential is a number between 1 and 3 inclusive that scores the potential savings for the user if they use that tactic. 1 is low, 2 is medium, 3 is high."
  ),
  effort: e.number().min(1).max(3).describe(
    "effort is a number between 1 and 3 inclusive that identifies how much effort it will be for the user to use this tactic. 1 is low, 2 is medium, 3 is high."
  ),
  applicability: e.number().min(1).max(5).describe(
    "applicability is a number between 1 and 5 inclusive that scores how applicable the tactic is to this situation. 1 is low, 5 is high applicability."
  )
}), r = e.enum([
  "sku",
  "vv-legacy-range",
  "company",
  "competitor",
  "category"
]), u = e.object({
  product_name: e.string(),
  data_quality: r,
  contract_overview: i,
  line_items: e.array(t),
  competitive_analysis: e.array(n),
  negotiation_insights: e.array(a).describe(
    "Using the list of negotiation tactics provided, please provide up to three negotiation tactics they should use, prioritized based on which would be most applicable to their situation. Remember to return 1-3 tactics in the response. Please prioritize and order the tactics based on their applicability to the situation."
  )
}), l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  competitiveAnalysisSchema: n,
  contractOverviewSchema: i,
  dataQualitySchema: r,
  lineItemSchema: t,
  negotiationInsightSchema: a,
  priceCheckOutputSchema: u
}, Symbol.toStringTag, { value: "Module" }));
export {
  n as a,
  i as c,
  r as d,
  t as l,
  a as n,
  u as p,
  l as v
};
